import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res = await axios.post('https://emmasimba.fixidu.com/api/admin-login', {
        mobile,
        password,
      });

     if (res.data.success) {
  localStorage.setItem('isAdminLoggedIn', 'true'); // ✅ set flag
  setMessage('Login successful!');
  navigate('/bookings');
      } else {
        setMessage('Invalid mobile number or password');
      }
    } catch (err) {
      console.error(err);
      setMessage('Login failed. Please try again.');
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#f5f5f5',
      }}
    >
      <div
        style={{
          background: '#fff',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          textAlign: 'center',
          width: '350px',
        }}
      >
        <img
          src="/Black LOGO.png"
          alt="Fixit Admin Logo"
          style={{ width: '120px', marginBottom: '20px' }}
        />
       <h2 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '6px' }}>👋 Hello Admin!</h2>
<p style={{ fontSize: '14px', color: '#666', marginBottom: '25px' }}>
Please log in to manage bookings and partner profiles
</p>

        <input
          type="text"
          placeholder="Enter mobile number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
          style={{
            padding: '10px',
            marginBottom: '15px',
            width: '95%',
            borderRadius: '8px',
            border: '1px solid #ccc',
          }}
        />
        <br />
        <input
          type="password"
          placeholder="Enter password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            padding: '10px',
            marginBottom: '20px',
            width: '95%',
            borderRadius: '8px',
            border: '1px solid #ccc',
          }}
        />
        <br />
        <button
          onClick={handleLogin}
          style={{
            padding: '10px 20px',
            width: '100%',
            backgroundColor: '#000',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 'bold',
          }}
        >
          Login
        </button>
        <p style={{ marginTop: '15px', color: '#e53935' }}>{message}</p>
      </div>
    </div>
  );
}
